import AR from 'assets/images/flags/ar.svg';
import AU from 'assets/images/flags/au.svg';
import BR from 'assets/images/flags/br.svg';
import ENCA from 'assets/images/flags/ca.svg';
import FRCA from 'assets/images/flags/ca.svg';
import CL from 'assets/images/flags/cl.svg';
import CN from 'assets/images/flags/cn.svg';
import CO from 'assets/images/flags/co.svg';
import DE from 'assets/images/flags/de.svg';
import FR from 'assets/images/flags/fr.svg';
import GB from 'assets/images/flags/gb.svg';
import ES from 'assets/images/flags/global.svg';
import EN from 'assets/images/flags/global.svg';
import IE from 'assets/images/flags/ie.svg';
import IN from 'assets/images/flags/in.svg';
import IT from 'assets/images/flags/it.svg';
import KR from 'assets/images/flags/kr.svg';
import MX from 'assets/images/flags/mx.svg';
import NZ from 'assets/images/flags/nz.svg';
import PE from 'assets/images/flags/pe.svg';
import PT from 'assets/images/flags/pt.svg';

const langs = {
  EN,
  ES,
  PT,
  PE,
  CL,
  CO,
  AR,
  MX,
  BR,
  IE,
  IN,
  GB,
  AU,
  NZ,
  KR,
  FR,
  DE,
  IT,
  CN,
  FRCA,
  ENCA,
};

export default langs;
